function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 448,
  height: 234,
  rx: 4,
  fill: "#4E6FFF"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 448,
  height: 234
}, /*#__PURE__*/React.createElement("rect", {
  width: 448,
  height: 234,
  rx: 4,
  fill: "#4E6FFF"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 232.985,
  cy: 206.066,
  r: 241.993,
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 180.348,
  r: 289.265,
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.148 199.853C389.857 217.839 396.503 237.515 397.006 254.765C397.508 272.021 391.869 286.756 380.126 295.054C368.383 303.351 352.611 303.746 336.513 297.51C320.422 291.276 304.094 278.441 291.385 260.455C278.676 242.469 272.03 222.793 271.528 205.543C271.026 188.287 276.665 173.552 288.408 165.255C300.15 156.957 315.923 156.562 332.02 162.798C348.112 169.032 364.439 181.868 377.148 199.853Z",
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.887 177.806C409.273 209.93 412.683 241.984 408.22 267.822C403.753 293.677 391.437 313.172 372.497 320.475C353.557 327.778 331.341 321.596 310.673 305.432C290.019 289.279 271.028 263.232 258.642 231.108C246.256 198.984 242.846 166.93 247.31 141.092C251.776 115.237 264.092 95.7419 283.032 88.4392C301.973 81.1364 324.188 87.3177 344.856 103.482C365.51 119.636 384.501 145.682 396.887 177.806Z",
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.754 293.361C152.222 320.133 141.632 343.236 128.214 358.951C114.783 374.679 98.6196 382.906 82.8964 380.245C67.1732 377.583 54.6178 364.494 47.1124 345.222C39.6133 325.967 37.2178 300.665 41.7497 273.894C46.2816 247.122 56.871 224.019 70.2898 208.304C83.72 192.576 99.8838 184.349 115.607 187.01C131.33 189.672 143.886 202.761 151.391 222.033C158.89 241.288 161.286 266.59 156.754 293.361Z",
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3824 227.148C19.4396 249.369 17.8685 274.082 20.0377 294.076C21.1219 304.071 23.1384 312.864 25.4962 319.554C26.6754 322.9 27.935 325.706 29.1976 327.868C30.4697 330.046 31.7079 331.507 32.8167 332.239C33.5554 332.727 34.2022 332.935 34.7741 332.951C35.3396 332.966 35.8974 332.795 36.4688 332.408C37.6494 331.61 38.8222 329.938 40.0018 327.395C42.3476 322.337 44.504 314.331 46.9662 304.692C47.2756 303.481 47.5896 302.244 47.9092 300.986C52.6574 282.294 58.6465 258.717 69.1153 239.645C78.5092 222.532 89.6951 209.71 98.5088 199.608C100.774 197.012 102.882 194.595 104.763 192.332C109.397 186.755 112.572 182.195 113.48 178.175C113.927 176.197 113.819 174.367 113.066 172.604C112.307 170.829 110.87 169.064 108.561 167.271C104.252 163.926 98.4628 163.119 91.7828 164.573C85.0998 166.028 77.6001 169.735 70.0002 175.3C54.8038 186.428 39.3436 204.886 29.3824 227.148Z",
  stroke: "white",
  strokeOpacity: 0.1,
  strokeWidth: 1.46959
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.958 -56.958C169.579 -40.6157 191.064 -18.1346 202.681 4.96733C214.301 28.0751 216.015 51.7171 205.286 70.5077C194.557 89.2983 173.325 99.8382 147.519 101.576C121.719 103.313 91.438 96.2369 62.8169 79.8946C34.1957 63.5523 12.7111 41.0712 1.09394 17.9693C-10.5261 -5.13849 -12.2407 -28.7806 -1.51145 -47.5712C9.21775 -66.3618 30.4497 -76.9017 56.2562 -78.6393C82.0562 -80.3766 112.337 -73.3003 140.958 -56.958Z",
  stroke: "white",
  strokeOpacity: 0.2,
  strokeWidth: 1.46959
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 386.392,
  cy: 63.3919,
  r: 29.3919,
  fill: "#17BEBB"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 369.737,
  cy: 54.0847,
  r: 1.95946,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 403.047,
  cy: 54.0847,
  r: 1.95946,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M386.467 65.5962C379.6 65.4728 371.526 60.4528 368.587 66.5761C366.341 71.2549 369.077 76.6183 372.996 80.0474C381.058 87.1018 392.121 87.1021 400.183 80.0474C404.102 76.6182 406.38 70.9498 403.857 66.5761C400.183 60.2077 394.153 65.7344 386.467 65.5962Z",
  stroke: "white",
  strokeWidth: 1.46959
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M382.718 55.799C382.718 57.2686 383.698 59.473 386.392 59.473C390.066 59.473 390.066 55.799 389.576 53.1047",
  stroke: "white",
  strokeWidth: 1.46959,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M251.207 60.1152C251.786 59.508 252.755 59.508 253.334 60.1152L286.573 94.9706C287.115 95.5383 287.115 96.4313 286.573 96.999L253.334 131.854C252.755 132.462 251.786 132.462 251.207 131.854L217.967 96.999C217.426 96.4313 217.426 95.5383 217.967 94.9706L251.207 60.1152Z",
  fill: "#EDC11B"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 241.493,
  cy: 90.3513,
  r: 1.95946,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 262.558,
  cy: 87.4121,
  r: 1.95946,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M248.38 95.5338C248.38 95.5338 256.701 91.812 257.592 96.1575C258.274 99.4849 249.888 100.195 249.888 100.195",
  stroke: "white",
  strokeWidth: 1.46959,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M249.992 108.851C254.75 111.714 261.769 108.726 262.554 103.083",
  stroke: "white",
  strokeWidth: 1.46959
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 315,
  y: 140,
  width: 53.3953,
  height: 53.3953,
  fill: "#DB504A"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 331.166,
  cy: 159.594,
  r: 1.95946,
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 352.23,
  cy: 159.594,
  r: 1.95946,
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M341.698 154.696L337.779 168.902H342.922",
  stroke: "white",
  strokeWidth: 1.46959,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M328.471 174.291C329.719 177.479 331.986 179.765 334.696 181.149M354.434 174.291C351.273 182.369 341.564 184.655 334.696 181.149M331.166 178.944C331.166 178.944 325.287 183.353 327.737 185.802C329.941 188.007 334.696 181.149 334.696 181.149",
  stroke: "white",
  strokeWidth: 1.46959,
  strokeLinecap: "round"
});

function SvgFeaturedCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 234,
    viewBox: "0 0 448 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedCard);
export default __webpack_public_path__ + "static/media/featured_card.b4f96606.svg";
export { ForwardRef as ReactComponent };